import { render, staticRenderFns } from "./insActivity.vue?vue&type=template&id=6d60d04c&"
import script from "./insActivity.vue?vue&type=script&lang=js&"
export * from "./insActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports